<template>
  <div>
    <b-card v-if="true" no-body class="overflow-hidden photo-card">
      <b-row >
        <b-col md="9">
          <b-card-img-lazy
            :src="coverImgURL"
            alt="Image"
            class="rounded-0 profile-bg"
          ></b-card-img-lazy>
          <b-icon-soundwave
              v-if="photoAudio"
              :variant="photoAudio ? 'warning': 'secondary'"
              class="photo-sound-btn"
              font-scale="3"
              @click="handlePlayAudio(photoAudio)"
              style="cursor:pointer"
          />
        </b-col>
        <b-col md="3">
          <b-card-body :title="photo.title ? photo.title : 'No Title'">
            <b-card-text>

              <h6>{{ photo.details ? photo.details : 'No Details. Please add.' }}</h6>
            </b-card-text>
            <b-card-text v-if="hasCreatedBy">
              <b-img
                v-bind="mainProps"
                :src="createdByImgURL"
                rounded="circle"
                alt="Circle image"
                left
              />
              <b-icon-soundwave
                  v-if="createdByAudio"
                  :variant="createdByAudio ? 'warning': 'secondary'"
                  font-scale="5"
                  @click="handlePlayAudio(createdByAudio)"
                  style="cursor:pointer;"
              />
              <template v-else> <!-- Stop this craziness -->
                <br/>
                <br/>
                <hr/>
              </template>
              <h5>Added by {{ createdByRelation }} {{ createdByName }}</h5>
            </b-card-text>
          </b-card-body>
        </b-col>
      </b-row>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "CallLog_PhotoCard",
  props: {
    photo: { //
      type: Object,
      default: () => {}
    },
    assetsUrlHome: {
      type: String,
      default: ""
    }
  },
  computed: {
    coverImgURL() {
      return this.photo.imgURL
        ? `${this.assetsUrlHome}${this.photo.imgURL}`
        : "";
    },
    iconImgProps() {
      if (this.photo.imgURL) {
        this.mainProps.src = `${this.assetsUrlHome}${this.photo.imgURL}`;
      }
      return this.mainProps;
    },
    photoAudio(){
      return this.photo && this.photo.audioURL ? this.photo.audioURL : false;
     // return `${this.assetsURLPath}audio/maryb.mp3`;
    },
    hasCreatedBy() {
      return Object(this.photo).hasOwnProperty("_created_by");
    },
    createdByName() {
      return this.hasCreatedBy ? this.photo._created_by.name : "";
    },
    createdByRelation() {
      return this.hasCreatedBy ? this.photo._created_by.relation : "";
    },
    createdByImgURL() {
      return this.hasCreatedBy ? this.photo._created_by.imgURL : "";
    },
    createdByAudio() {
      return this.hasCreatedBy && this.photo._created_by.audioURL ?
          this.photo._created_by.audioURL : false;
     // return `${this.assetsURLPath}audio/createdbyaudio.mp3`;
    },
    createdAt() {
      return this.hasCreatedBy ? this.photo._created_by._created_at : "";
    }
  },
  methods:{
    handlePlayAudio(audioURL){
      this.player = new Audio(audioURL);
      let that = this; // Check that there are no issues with this
      this.player.addEventListener("ended", function() {
          that.player.pause();
      });
      //this.audioDuration = this.getDuration(this.player.duration);
      if (this.player) {
        this.player.play();
      }
    }
  },
  data() {
    return { //https://d3rriana.com/assets/apps/photoalbum/audio/maryb.mp3
      assetsURLPath:'/assets/apps/calllog/',
      player:null,
      mainProps: {
        blank: false,
        blankColor: "#777",
        width: 75,
        height: 75,
        class: "m1"
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.photo-card {
  width: 100%;
  //   height: 357px;
  filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
  border-radius: 8px !important;
  background: #ffffff;
  position: relative;
  font-family: "Nunito", sans-serif;
  .photo-bg {
    width: 100%;
    background: rgba(184, 136, 92, 0.1);
    background-color: #ddbc9e;
    border-top-left-radius: 8px !important;
    border-top-right-radius: 8px !important;
    background-repeat: repeat-x;
  }
  .photo-sound-btn {
    position: absolute;
    left: 0%;
    top: 85%;
    text-align: left;
    background-color: rgba(10, 9, 9, 0.7);
    color: #272f75;
    font-weight: bold;
    cursor: pointer;
    height: 55px;
    width: 135px;
    font-size: 12px;
  }
}
</style>
